export default "__VITE_ASSET__BvZGBHFQ__"